const productCategoryApiErrorMappings = {
  name: { 'value is not unique': 'Sudah terdaftar di sistem.' },
  box_type_ids: {
    "already used in another product category": 'Sudah digunakan di produk kategori lainnya',
  }
}

export default productCategoryApiErrorMappings
